<template>
    <div class="bbt-main">
        <div class="main">
            <div class="author-banner" style="height:190px;">
                <img class="author-banner__bg" src="../assets/usercenter@2x.png" style="height: 262px;width:100%;" />
                <div class="bbt-container"></div>
            </div>
            <div class="user-module">
                <div class="user-module__stat">
                    <div class="bbt-container">
                        <div class="user-module__item"><span>0</span>关注</div>
                        <div class="user-module__space"></div>
                        <div class="user-module__item"><span>0</span>粉丝</div>
                    </div>
                </div>
                <div class="user-module__info">
                    <div class="bbt-container">
                        <div class="user-module__avatar">
                            <div class="bbt-avatar" lazy="loaded" :style="{backgroundImage: `url(${user.avatar})`}"></div>
                        </div>
                        <div class="user-module__name">
                            {{user.username}}
                            <!-- <span style="background: rgb(20, 149, 75);">保密</span> -->
                        </div>
                        <div class="user-module__signature">
                            {{user.description ==''? '这个人很懒，没有写个性签名':user.description}}
                        </div>
                        <div class="user-module__btn">
                            <router-link to="/userEdit/1" class="bbt-btn bbt-btn--primary bbt-btn--lg" id="accountSet" style="width: 120px;">
                                账号设置
                            </router-link>
                            <!-- <a href="/user/settings" class="bbt-btn bbt-btn--primary bbt-btn--lg" style="width: 120px;">账号设置</a> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="bbt-tab">
                <div class="bbt-container">
                    <div class="bbt-tab__relative">
                        <ul class="bbt-tab__menu bbt-clearfix">
                            <li class="active" @click="transActiveLine" data-view="/userDetailPost">
                                帖子
                            </li>
                            <li class="" @click="transActiveLine" data-view="/userDetailArticle">
                                文章
                            </li>
                            <li class="" @click="transActiveLine" data-view="/userDetailCollection">
                                收藏
                            </li>
                            <li class="" @click="transActiveLine" data-view="/userDetailPaper">
                                试卷
                            </li>
                            <li class="" @click="transActiveLine" data-view="/userDetailPermission">
                                我的申请
                            </li>
                        </ul>
                        <div class="li-active__line" style="left: 24px; width: 40px; opacity: 1;"></div>
                    </div>
                </div>
            </div>
            <div class="main-body">
                <div class="bbt-container">
                    <transition name="slide-fade">
                        <router-view :serveHost="serverURL"></router-view>
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'UserDetail',
    props:{
        serveHost: String
    },
    data () {
        return {
            publicPath: process.env.BASE_URL,
            serverURL: process.env.VUE_APP_URL,
            showApplyPost:0,
            user:{},
            // mainContainer:[
            //     'UserDetailPost'
            // ],
            mainView:''
        }
    },
    methods:{
        transActiveLine:function(event) {
            // Tab切换
            var _vm = this;
            var l_offset = event.target.offsetLeft;
            var w_offset = event.target.offsetWidth;
            // 类型
            let eventType = event.target.dataset.type;
            $(event.target).parent().siblings('.li-active__line').css({left:l_offset});
            $(event.target).parent().siblings('.li-active__line').width(w_offset);
            $(event.target).attr('class', 'active').siblings().removeAttr('class');
            let childrenPath = event.target.dataset.view;
            // _vm.articleType = event.target.dataset.cid;
            // _vm.hasMoreArticle = false;
            // _vm.articleLoad = true;
            // _vm.loadArticleList(_vm, 1, _vm.articleType);
            // setTimeout(function(){
            //     _vm.articleLoad = false;
            // },2000)

            // tab页切换
            let oldPath = this.$route.path.substr(0, this.$route.path.lastIndexOf('/'))
            this.$router.push({path: oldPath + childrenPath});
        },
        loadArticleList:function(_vm, pagNo, category) {
            if(category != '') {
                _vm.articleNews = [];
            }
            // 快讯
            this.loadDataByAsync(_vm.serveHost + "/api/v1/article/getFlashArticle", {
                pageNo: pagNo,
                category: category
            }, function(r){
                if(r.code != "2000000") {
                    console.error('get more article error.');
                    // return;
                }
                if(r.data) {
                    r.data.forEach((item, index) => {
                        _vm.articleNews.push(item);
                    });
                    _vm.articleLoad = false;
                    _vm.hasMoreArticle = true;
                } else {
                    _vm.hasMoreArticle = false;
                    _vm.$message('没有更多的快讯了');
                }
            });
        },
        loadDataByAsync:function(URL, DATA, CALLBACK_FUNC) {
            $.get(URL, DATA, CALLBACK_FUNC);
        },
    },
    created() {
        this.user = JSON.parse(localStorage.user)
        // this.$router.push({path: this.$route.path + '/UserDetailPost'})
    }
}
</script>

<style scoped>
#accountSet {
    background-color:#fff;
    color:#409EFF;
    border:1px solid #409EFF;
}

#accountSet:hover{
    background-color:#409EFF;
    color:#fff;
}
.bbt-avatar {
    width: 136px;
    height: 136px;
    background-repeat: no-repeat;
    background-position: 50%;
    background-size: cover;
    border-radius: 50%;
    overflow: hidden;
}
.user-module__info {
    margin-bottom: 48px;
    position: relative;
    padding-top: 90px;
}


.main-body {
    margin: 32px 0 0;
}
.bbt-tab .li-active__line {
    height: 4px;
    position: absolute;
    left: 0;
    bottom: 0;
    border-radius: 2px;
    background: #e00;
    transition: all .3s ease;
}
.bbt-tab__menu>li.active {
    font-weight: 700;
}
.bbt-tab__menu>li.active, .bbt-tab__menu>li:hover {
    color: rgba(0,0,0,.88);
}
.bbt-tab__menu>li {
    position: relative;
    font-size: 20px;
    line-height: 28px;
    color: rgba(0,0,0,.56);
    display: inline-block;
    list-style: none;
    font-weight: 700;
    transition: all .3s ease;
    height: 52px;
    line-height: 52px;
    margin: 0 24px;
    cursor: pointer;
}
.bbt-tab__menu {
    display: inline-block;
    position: relative;
    list-style: none;
    text-align: center;
    padding: 0;
    margin: 0;
}
.bbt-tab__relative {
    display: inline-block;
    position: relative;
}
.bbt-tab {
    position: relative;
    text-align: center;
    border-bottom: 1px solid rgba(0,0,0,.08);
}
.user-module__name>span {
    display: inline-block;
    border-radius: 12px;
    color: #fff;
    background: #177ed7;
    vertical-align: top;
    margin-left: 8px;
    font-size: 12px;
    line-height: 20px;
    line-height: 12px;
    padding: 4px;
    vertical-align: middle;
}
.bbt-btn.bbt-btn--primary {
    color: #fff;
    background: #409EFF;
    border-color: #409EFF;
    transition: all .3s ease;
}

.bbt-btn.bbt-btn--lg {
    font-size: 14px;
    padding: 12px 18px;
    border-radius: 4px;
}
.bbt-btn {
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    touch-action: manipulation;
    cursor: pointer;
    white-space: nowrap;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    font-size: 14px;
    font-weight: 500;
    padding: 9px 15px;
    line-height: 1;
    border: 1px solid transparent;
    background: none;
    border-radius: 4px;
    outline: none;
}
.user-module__btn {
    margin-top: 24px;
}
.user-module__signature {
    color: rgba(0,0,0,.56);
    font-size: 14px;
    line-height: 22px;
}
.user-module__name {
    color: rgba(0,0,0,.88);
    font-size: 20px;
    line-height: 28px;
    font-weight: 700;
    margin-bottom: 8px;
}
/* .user-module__avatar:after {
    content: "";
    display: block;
    width: 128px;
    height: 128px;
    border: 4px solid hsla(0,0%,100%,.88);
    position: absolute;
    left: 0;
    top: 0;
    border-radius: 50%;
} */
.user-module__avatar {
    width: 128px;
    height: 128px;
    position: absolute;
    top: -52px;
    left: 50%;
    transform: translateX(-50%);
}
.user-module__item:last-child:after {
    content: "";
    width: 0;
    height: 36px;
    position: absolute;
    left: 0;
    top: 6px;
    border-left: 1px dashed hsla(0,0%,100%,.64);
}
.user-module__item span {
    display: block;
    font-size: 20px;
    line-height: 28px;
    color: #fff;
}
.user-module__space {
    display: inline-block;
    margin: 0 25px;
    width: 152px;
    height: 48px;
}
.user-module__item:first-child:after {
    content: "";
    width: 0;
    height: 36px;
    position: absolute;
    right: 0;
    top: 6px;
    border-right: 1px dashed hsla(0,0%,100%,.64);
}
.user-module__item {
    display: inline-block;
    width: 132px;
    color: hsla(0,0%,100%,.64);
    font-size: 12px;
    line-height: 20px;
}
.user-module, .user-module__item {
    position: relative;
    text-align: center;
}
.bbt-container:after {
    clear: both;
}
.bbt-container:after, .bbt-container:before {
    display: table;
    content: "";
}
@media (min-width: 1200px) {
    .bbt-container {
        width: 1200px;
    }
}
.bbt-container {
    padding-left: 12px;
    padding-right: 12px;
    margin: 0 auto;
}
.author-banner__bg {
    padding: 18px 0;
    background-repeat: no-repeat;
    background-position: 50%;
    background-size: cover;
    color: #fff;
}
.bbt-main {
    padding-bottom: 48px;
}
</style>